"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ContentItemUtilities = void 0;

var _react = _interopRequireDefault(require("react"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _mobxReact = require("mobx-react");

var _Propulator = _interopRequireDefault(require("../../../higher-order/Propulator"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _join = _interopRequireDefault(require("lodash/join"));

var _trim = _interopRequireDefault(require("lodash/trim"));

var _map = _interopRequireDefault(require("lodash/map"));

var _excluded = ["sharedKey", "tag", "className", "contentKey", "stringFormatArgs", "extractContent"];

var _class, _class2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentItem = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentItem, _React$Component);

  var _super = _createSuper(ContentItem);

  function ContentItem() {
    _classCallCheck(this, ContentItem);

    return _super.apply(this, arguments);
  }

  _createClass(ContentItem, [{
    key: "id",
    get: function get() {
      return (0, _join.default)((0, _filter.default)((0, _map.default)({
        sharedKey: this.props.sharedKey,
        contentKey: this.props.contentKey
      }, function (v) {
        return (0, _trim.default)(v);
      })), "-");
    }
  }, {
    key: "render",
    value: function render() {
      // Destructure props so we can pull out the things we need to process and leave additional attributes intended for the
      // returned element
      var _this$props = this.props,
          sharedKey = _this$props.sharedKey,
          tag = _this$props.tag,
          className = _this$props.className,
          contentKey = _this$props.contentKey,
          stringFormatArgs = _this$props.stringFormatArgs,
          extractContent = _this$props.extractContent,
          otherProps = _objectWithoutProperties(_this$props, _excluded); // We don't want to stick the dispatcher into the element we are creating


      delete otherProps.dispatcher;
      var outputContent = extractContent(contentKey, sharedKey, stringFormatArgs);
      var cssClasses = (0, _classnames.default)("content-item", className); // Put any passthrough attributes into the input object for React.createElement

      var props = _objectSpread({
        className: cssClasses,
        dangerouslySetInnerHTML: {
          __html: outputContent
        }
      }, otherProps);

      return /*#__PURE__*/_react.default.createElement(tag, props);
    }
  }]);

  return ContentItem;
}(_react.default.Component), _defineProperty(_class2, "propTypes", {
  tag: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  contentKey: _propTypes.default.string.isRequired,
  sharedKey: _propTypes.default.string,
  stringFormatArgs: _propTypes.default.object
}), _defineProperty(_class2, "defaultProps", {
  tag: "div"
}), _class2)) || _class;

var ContentItemUtilities = /*#__PURE__*/_createClass(function ContentItemUtilities() {
  _classCallCheck(this, ContentItemUtilities);
});

exports.ContentItemUtilities = ContentItemUtilities;

_defineProperty(ContentItemUtilities, "stringifyComponent", function (component) {
  return _server.default.renderToString(component);
});

var _default = (0, _Propulator.default)(ContentItem, {
  contentStore: ["extractContent"]
});

exports.default = _default;